import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Logo: FunctionComponent<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg version='1.1' x='0px' y='0px' viewBox='0 0 138.8 34.3' enableBackground='new 0 0 138.8 34.3' {...props}>
        <g>
            <polygon fill='#455A64' points='48.4,5.8 32.8,28.5 27.2,28.5 43.1,5.8 	' />
            <g>
                <path fill='#455A64' d='M85.5,18.4v5.3h8.1v4.8H80.7V5.9h12.9v4.7h-8.2v4.2L85.5,18.4L85.5,18.4z' />
            </g>
            <circle fill='#FF6600' cx='40.4' cy='25.8' r='2.6' />
            <circle fill='#99CF16' cx='89.5' cy='17.1' r='2.6' />
            <g>
                <polygon fill='#8FA4AE' points='45,15.8 42.1,20 47.9,28.5 53.3,28.5 		' />
            </g>
            <g>
                <polygon fill='#8FA4AE' points='68.9,15.8 66,20 71.9,28.5 77.2,28.5 		' />
            </g>
            <polygon fill='#455A64' points='61.5,21.4 72.3,5.9 67,5.9 61.5,13.2 61.5,5.9 56.7,5.9 56.7,28.2 56.7,28.5 60.9,22.3 	' />
            <polygon
                fill='#455A64'
                points='7.2,10.6 17.3,10.6 4.9,28.4 8.9,28.4 8.9,28.4 23.7,28.5 23.7,23.7 13.8,23.7 26.1,5.8 7.2,5.8
   '
            />
            <g>
                <path fill='#455A64' d='M125.7,18.4v5.3h8.2v4.8H121V5.9h12.9v4.7h-8.2v4.2V18.4z' />
            </g>
            <circle fill='#F0047F' cx='129.7' cy='17.1' r='2.6' />
            <g>
                <polygon fill='#8FA4AE' points='109.3,15.8 106.4,20 112.2,28.5 117.6,28.5 		' />
            </g>
            <polygon fill='#455A64' points='101.8,21.4 112.6,5.9 107.3,5.9 101.8,13.2 101.9,5.9 97.1,5.9 97.1,28.2 97.1,28.5 101.3,22.3' />
        </g>
    </svg>
);

const LogoZakeke = styled(Logo)``;

export default LogoZakeke;
